import { RealTimeService } from '../../services/realtime.service';
import { Injectable } from '@angular/core';
import { BehaviorSubject, forkJoin, map, mergeMap, Observable, switchMap } from 'rxjs';
import { UserSession } from './user.session';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class UserSessionRegistryService {

  private static PATH = 'user-sessions';

  private readonly _meBehaviorSubject = new BehaviorSubject<UserSession>(null);

  private readonly _registryBehaviorSubject = new BehaviorSubject<UserSession[]>([]);
  public registry$ = this._registryBehaviorSubject.asObservable();

  get me$() {
    return this._meBehaviorSubject;
  }

  constructor(private readonly realtimeService: RealTimeService, private readonly httpClient: HttpClient) {
    this.init();
  }

  private init() {
    this.realtimeService.watch<Set<UserSession>>(UserSessionRegistryService.PATH)
      .pipe(map(connectedUserSessions => Array.from(connectedUserSessions)))
      .subscribe(registry => this.updateRegistry(registry));

    this.realtimeService.isConnected$().pipe(
      mergeMap(() => forkJoin([
        this.getMe(),
        this.getAll()
      ]))
    ).subscribe(([userSession, registry]) => {
      this.updateMe(userSession);
      this.updateRegistry(registry);
    });
  }

  public getOthersConnectedUserSessions$(): Observable<UserSession[]> {
    return this._meBehaviorSubject.pipe(
      switchMap(me => this.registry$.pipe(
        map(connectedUserSessions => connectedUserSessions.filter(session => session.stompSessionId !== me?.stompSessionId))
      ))
    );
  }

  public isMe(sessionId: string): boolean {
    return sessionId === this._meBehaviorSubject.value?.stompSessionId;
  }

  private getMe(): Observable<UserSession> {
    return this.httpClient.get<UserSession>(
      `${environment.api_base_url}${UserSessionRegistryService.PATH}/me`
    );
  }

  private updateMe(userSession: UserSession) {
    this._meBehaviorSubject.next(userSession);
  }

  private updateRegistry(registry: UserSession[]) {
    this._registryBehaviorSubject.next(registry);
  }

  private getAll(): Observable<UserSession[]> {
    return this.httpClient.get<UserSession[]>(`${environment.api_base_url}${UserSessionRegistryService.PATH}`);
  }
}
